Handlebars.registerHelper('ifEquals', function(arg1, arg2) {
  return (arg1 == arg2) ? (this) : !(this);
});
Handlebars.registerHelper('ifLess', function(arg1, arg2) {
  return (arg1 < arg2) ? (this) : !(this);
});
Handlebars.registerHelper('ifGreater', function(arg1, arg2) {
  return (arg1 > arg2) ? (this) : !(this);
});


window.theme = window.theme || {};
theme.Currency = (function(){
  var moneyFormat = $('#shop_currency_val').text();
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  return {
    formatMoney: formatMoney
  }
})();
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $){
  var shop_currency = $('#shop_currency_val').text();
  'use strict';
  var init, loadCart;
  var settings, isUpdating, $body;
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, validateQty;
  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options){
	settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#cart_container_id',
      addToCartSelector  : 'button[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : shop_currency,
      disableAjaxCart    : false,
      enableQtySelectors : false
    };
	$.extend(settings, options);
	$formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
	$body = $('body');
	isUpdating = false;
	if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }
	adjustCart();
  };
  loadCart = function () {
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };
  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, ''));
    }
  };
  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();
      wc_theme_source.lib.addtocart_form(evt.target, itemAddedCallback, itemErrorCallback)
    });
  };
  itemAddedCallback = function (product) {
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };
  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');
    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };
  cartUpdateCallback = function (cart){
    updateCountPrice(cart);
    buildCart(cart);
  };
  buildCart = function(cart){
    $cartContainer.empty();
	if (cart.item_count === 0) {
      $cartContainer
        .append('<div class="amptyclscart"><p>' + "YOUR SHOPPING CART IS EMPTY" + '</p><div data-rebuy-id="97221"></div></div>');
      cartCallback(cart);
      return;
    }
	var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);
	$.each(cart.items, function(index, cartItem) {
	  if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_200x200$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
             delete cartItem.properties[key];
           }
        });
      }
      var options = [];
      $.each(cartItem.options_with_values,function(i,option){
        if(option.value == "Default Title"){

        }else if(option.name == "Size" || option.name == "size" || option.name == "SIZE"){
          option = {
            option_name : option.name,
            option_value : option.value,
          }
        }else{
        
        }
        options.push(option);
      });
      var pro_id_cart = cartItem.product_id;
      var variants = [],variant_len;
      var comp_price;
      $.ajax({
        url:'/products/'+cartItem.handle+'.js',
        type:'GET',
        dataType: "json",
        async:false,
        success: function(product){
          comp_price = product.compare_at_price;
          variant_len = product.variants.length;
          $.each(product.variants, function(key, value){
            value = {
              variant_name : value.title,
              variant_id : value.id,
              variant_available : value.available,
              variant_current:cartItem.variant_title
            }
            variants.push(value);
          });   
          
              setTimeout(()=>{
                  let slideshow2 = new Swiper('.swiper-container', {
            	loop: true,
            	effect: 'fade',
                spaceBetween: 30,
                autoHeight: true,
            	autoplay: {
            		delay: 2000
            	},
            	navigation: {
            		nextEl: ".controls .next",
            		prevEl: ".controls .prev"
            	},
                pagination: {
                      el: ".swiper-pagination",
                      clickable: true,
                    },fadeEffect: {
                  crossFade: true,
                },
            });
            if (screen.width < 991){
               let slideshow2 = new Swiper('.swiper-product', {
            	loop: true,
                spaceBetween: 2,
                slidesPerView: 1,
                 slidesOffsetBefore: 5,
                centeredSlides: true,
                  initialSlide: 0,
                 loopedSlides: 32,
            	// autoplay: {
            	// 	delay: 5000
            	// },
            	navigation: {
            		nextEl: ".controls .next",
            		prevEl: ".controls .prev"
            	},
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true
                }
            });
            }
                },2000);
        },
        error: function(error){
          console.log(error);
        }        
      });  
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        mainname:cartItem.product_title,
        variation: cartItem.variant_title,
        type:cartItem.product_type,
        optionval:options,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, shop_currency),
        compprice:Shopify.formatMoney(comp_price, shop_currency),
        lineprice: Shopify.formatMoney(cartItem.line_price, shop_currency),
        discountedPrice: Shopify.formatMoney((cartItem.price - (cartItem.total_discount/cartItem.quantity)), shop_currency),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.price === (cartItem.price - cartItem.total_discount) ? false : true,
        vendor: cartItem.vendor,
        id: cartItem.variant_id,
        pro_id:cartItem.product_id,
        variantslist:variants,
        varlength:variant_len
      };
      items.push(item);
    });
	data = {
      items: items,
      note: cart.note,
      totalitemcount:cart.item_count,
      totalPrice: Shopify.formatMoney(cart.total_price, shop_currency),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "translation missing: en.cart.general.savings_html".replace('[savings]', theme.Currency.formatMoney(cart.total_discount, settings.moneyFormat))
    };    
    $cartContainer.append(template(data));
    cartCallback(cart);
    $('.final_Select').on('change', function() {
      var select_var_id = $('option:selected', this).attr('data-id');
      $('.finalchangecart').attr('data-id',select_var_id);
    });
    $('.cartdrawer_var').on('change', function() {
      var drawer_var_id = $('option:selected', this).attr('data-varid');
      var variant_qty = $(this).data('qty');
      var currentid = $(this).data('varid');
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { id: drawer_var_id, quantity: variant_qty },
        dataType: "json",
        beforeSend: function () {
          //$("body").addClass("loading");
        },
        success: function (t) {
            $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: "quantity=0&id=" + currentid,
            dataType: "json",
            success: function (e) {
              ajaxCart.load();
              //wc_theme_source.lib.get_cart(buildCart);              
            },
            error: function (e, t) {
              console.log(e.responseJSON.description);              
            },
          });
        },
        error: function (e, t) {
          console.log(e.responseJSON.description);
        },
      });
    });
  };
  cartCallback = function(cart){
    $body.trigger('ajaxCart.afterCartLoad', cart);
    wc_theme_source.lib.on_cart_update(cart);
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };
  adjustCart = function(){
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.parents('ul.QuantityBox').find('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val());
      var qty = validateQty(qty);
	  if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
	  if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
    $body.on('click', '.cart_remove_item', function(){
      var line = $(this).attr('data-line');
      wc_theme_source.lib.cart_remove_item(line, adjustCartCallback)
    });
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));
      var qty = validateQty(qty);
	  if (line) {
        updateQuantity(line, qty);
      }
    });
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });
	$body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });
    function updateQuantity(line, qty) {
      isUpdating = true;
	  var $row = $('.Quantity_cart_slider[data-line="' + line + '"]').addClass('is-loading');
      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }
      setTimeout(function() {
        wc_theme_source.lib.cart_change_item(line, qty, adjustCartCallback);
      }, 250);
    }
  };
  adjustCartCallback = function (cart) {
    updateCountPrice(cart);
	setTimeout(function() {
      wc_theme_source.lib.get_cart(buildCart);
      isUpdating = false;
    }, 150)
  };
  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
    } else {
      qty = 1;
    }
    return qty;
  };
  module = {
    init: init,
    load: loadCart
  };  
  $(document).on('click', '.finalchangecart', function(e){
    e.preventDefault();    
    var gift_pro_id = $(this).attr('data-id');
    var o = {
      type: "POST",
      url: "/cart/add.js",
      data: "quantity=1&id="+gift_pro_id,
      dataType: "json",
      success: function (line_item) {
        ajaxCart.load();
        //wc_theme_source.lib.get_cart(buildCart);  
        setTimeout(function(){
          $('body').addClass('CartOpen');
        },500);        
      },
      error: function (XMLHttpRequest, textStatus) {        
        if((typeof errorCallback) === 'function'){
          errorCallback(XMLHttpRequest, textStatus);
        } else{
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      },
    };
    jQuery.ajax(o);
  });  

  

  $(document).on('click', '.pro_selectsize .size_grid .sizegrid_btn', function () {
    var line = $(this).attr('data-id');
    addItemNew(line)
  });
  $(document).on('click', '.singal-add-btn span', function () {
    var line = $(this).attr('data-id');
    addItemNew(line)
  });

  function addItemNew(line) {
    let data = {
     'items': [{
      'id': line,
      'quantity': 1
      }]
    };
    fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
      })
      .then((response) => response.json())
      .then((data) => {
          ajaxCart.load();
          setTimeout(function(){
            $('body').addClass('CartOpen');
          },500);
      })
      .catch((error) => {
          console.error('Error:', error);
    });
  }
  
  
  $(document).on('click','.activecart',function(e){
    // e.preventDefault();
    // var variant_id = $(this).closest('.pro_column').find('.size_grid li.active .sizegrid_btn').data('id');
    // var added_text = $('.gridcartbtn').data('added');
    // var error_text = $('.gridcartbtn').data('errortext');
    // var addcart_text =  $('.gridcartbtn').data('btntext');
    // var cartbtn = $(this).closest('.pro_column').find('.gridcartbtn');
    // var error_msgclss = $(this).closest('.pro_column').find('.error_msgsize');
    // var sizelimit = $(this).closest('.pro_column').find('.cart_limit_label');
    // function addcartdata(){
    //   $.ajax({
    //     type:'POST',
    //     url:'/cart/add.js',
    //     dataType:'json',
    //     data:{id:variant_id,quantity:1},
    //     beforeSend: function() {
    //       $(cartbtn).text('loading..');
    //     },
    //     success:function(response) {       
    //       $(cartbtn).text(added_text);
    //       setTimeout(function(){
    //         $(cartbtn).text(addcart_text);
    //       },3000);
    //       ajaxCart.load();
    //       setTimeout(function(){
    //         $('body').addClass('CartOpen');
    //       },500);
    //     },
    //     error: function(XMLHttpRequest, textStatus){
    //       $(error_msgclss).text(XMLHttpRequest.responseJSON.description);
    //       $(cartbtn).text(error_text);
    //       setTimeout(function(){
    //         $(error_msgclss).empty();
    //         $(cartbtn).text(addcart_text);
    //       },3000);
    //     }
    //   });
    // }
    
    var data_qtylimit = $('.qty_size_limit').data('qty');
    var submitform = true;
    $.ajax({
      url:'/cart.js',
      type:'GET',
      dataType: "json",
      success: function(data){
        if(data.item_count > 0){
          $.each(data.items, function(key, value){
            var eachitemqty = value.quantity;
            if(variant_id==value.id){
              if(eachitemqty<data_qtylimit){
                submitform = true;
              } else{
                submitform = false;
                $(sizelimit).show();
                setTimeout(function(){
                  $(sizelimit).hide();
                },2000);
              }
            }
            if(key === data.items.length -1){
              if(submitform){
               addcartdata();
              }
            }
          });
        } else{
          addcartdata();
        }
      }
    });    
  }); 
  var shipamount = $('.ship_rate').data('amount');
  var rate_price = Shopify.currency.rate*100;
  var new_shipamount = shipamount*rate_price;
  $.ajax({
    url:'/cart.js',
    type:'GET',
    dataType: "json",
    success: function(data){
      var cart_total = data.total_price;
      var newshiprate = new_shipamount - cart_total;
      if(new_shipamount>cart_total){
        $('.rate_shipcls').show();
        $('.free_shipcls').hide();
        var rate_withmoney = Shopify.formatMoney(newshiprate, shop_currency_default);
        $('.ship_rate').text(rate_withmoney);
      }else{
        $('.rate_shipcls').hide();
        $('.free_shipcls').show();
      }
    }
  });
  return module;
}(ajaxCart || {}, jQuery));
var shop_currency_default = $('#shop_currency_val').text();
var shop_currency;
function myCartSection() {
  var windowheight = $(window).height();
  var cartsidepanel = $('.cart-side-panel').height();
  if(cartsidepanel > windowheight){
  	$('.cart-side-panel').addClass('cartscroll');
  }else{
  	$('.cart-side-panel').removeClass('cartscroll');
  }
}
jQuery(window).resize(function(){
  myCartSection();
});
if(typeof $.cookie('currency') === 'undefined'){
  shop_currency = shop_currency_default;
} else{
  shop_currency = $.cookie('currency');
}
var wc_theme_source = {
  lib:{
    ajax_error: function(error, message){
      var data = eval('('+error.responseText+')');
      if (!!data.message) {
        //$('#added_product_popup').find('h3').text(data.description);
      }
    },
    on_cart_update: function(item){
      setTimeout(function(){
        $.ajax({
          url:'/cart',
          type:'GET',
          success: function(data){
            var parsed = $.parseHTML(data);
            if($(parsed).length > 0){
              if(parsed != null && parsed != '' && parsed != undefined){
                $(parsed).find(".cp_only_color").each(function(e){
                  var all_col_html = $(this).prop('outerHTML');
                  var all_col_id = $(this).attr('data-id');
                  $('.items_row').each(function(e){
                    var eachitemid = $(this).attr('data-id');
                    if(eachitemid==all_col_id){
                      $(this).find('.cdp_colors').html($(parsed).find('.cp_only_color[data-id="'+eachitemid+'"]').html());
                    }
                  });
                });     
              }
            }
          }
        });
        jQuery.getJSON('/cart.js', function(cart) {                       
          $('.cart_countcls').html(cart.item_count);            
          if(cart.item_count > 0){
            var cart_price = Shopify.formatMoney(cart.total_price, shop_currency_default);
            if($('.items_carts span').hasClass('money')){
              $('.items_carts span').remove();
              $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
            } else{
              $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
            }           
          } else{
            $('.items_carts span').remove();
            $('.items_carts').html("<span class='money'>$0.00</span>");                     
          }
          setTimeout(function(){
            //currenciesCallbackSpecial('.items_carts span.money');    
            myCartSection();
          },1000);
        });
      },100);
      var proarry = [];
      var productId = $('.change_pro_cls').data('id');      
      if(productId != '' || productId != null || productId != undefined){
        $('.items_row.CartItem').each(function(){          
          var cartItemId = $(this).data('proid');
          proarry.push(cartItemId);
        });
        if (jQuery.inArray(productId, proarry)!='-1') {
          $('.cartbtmpro').hide();         
        }else{
          $('.cartbtmpro').show();         
        }
      }
    },
    on_item_added: function(item){
      //wc_theme_source.lib.on_cart_update(item);
      ajaxCart.load();
    },
    on_product: function(e){
      console.log("Received everything we ever wanted to know about " + e.title);
    },
    addtocart_product: function(id, qty, callback){
      var qty = qty || 1;
      var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + qty + "&id=" + id,
        dataType: "json",
        success: function(item){
          if((typeof callback) === 'function'){
            callback(item, id);
          } else{
            wc_theme_source.lib.on_item_added(item);
          }
          setTimeout(function(){
            $('body').addClass('CartOpen');
          },500);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          console.log(XMLHttpRequest);
        }
      };
      jQuery.ajax(ajax);
    },
    get_product: function(handle, callback){
      jQuery.getJSON("/products/" + handle + ".js", function(product, n){
        wc_theme_source.lib.on_product(product);
      });
    },
    get_cart: function(callback){
      jQuery.getJSON("/cart.js", function(cart, textstatus){
        if((typeof callback) === 'function'){
          callback(cart);
        } else{
          wc_theme_source.lib.on_cart_update(cart);
        }
      });
    },
    addtocart_form: function(form_id, callback, errorCallback){
      var ajax = {
        type: 'POST',
        url: '/cart/add.js',
        data: jQuery('#' + form_id).serialize(),
        dataType: 'json',
        beforeSend: function(){
          jQuery('#'+form_id).find(".cart_btn_class").attr("disabled", true);
        },
        success: function(item){
          if((typeof callback) === 'function'){
            callback(item, form_id);
          } else{
            wc_theme_source.lib.on_item_added(item);
          }
          jQuery('#'+form_id).find(".cart_btn_class").attr("disabled", false);          
		  setTimeout(function(){
            //$('body').addClass('CartOpen');
          },500);
        },
        error: function(XMLHttpRequest, textStatus){
          $('.error_cartpro').text(XMLHttpRequest.responseJSON.description);
          if((typeof errorCallback) === 'function'){
            errorCallback(XMLHttpRequest, textStatus);
          } else{
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
          $('.btnpro_error').text(XMLHttpRequest.responseJSON.description);
          setTimeout(function(){
            $('.btnpro_error').empty();
          },3000);
        }
      };
      jQuery.ajax(ajax);
    },
    cart_change_item: function(line, qty, callback){
      var ajax = {
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + qty + '&line=' + line,
        dataType: 'json',
        success: function(cart){
          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    cart_remove_item: function(line, callback){
      var ajax = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + line,
        dataType: "json",
        beforeSend: function(){
          jQuery('.cart_loader_cls_id').show();
        },
        success: function(cart){
          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
          jQuery('.cart_loader_cls_id').hide();
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    cart_clear_all: function(){
      var ajax = {
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function(cart){
          wc_theme_source.lib.on_cart_update(cart);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    },
    update_cart_form: function(form){
      var ajax = {
        type: "POST",
        url: "/cart/update.js",
        data: jQuery("#" + form).serialize(),
        dataType: "json",
        beforeSend: function(){
          jQuery('#'+form).find(".cart_btn_class").attr("disabled", true);
        },
        success: function(cart){
          wc_theme_source.lib.on_cart_update(cart);
          jQuery('#'+form).find(".cart_btn_class").attr("disabled", false);
        },
        error: function(XMLHttpRequest, textStatus){
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(ajax);
    }
  }
}
$(document).on('click','.header_cart',function(e){  
  $('body').toggleClass('CartOpen');
  $('body').removeClass('accountopen open-filter open_search menu-open currency_open');
  return false;
});
jQuery(document).ready(function(){
  ajaxCart.load();
});
document.addEventListener('rebuy.add', function(event){
    // console.log('rebuy.add event', event.detail);
    ajaxCart.load()
});